export default __webpack_public_path__ + "static/media/cart.db11a0f6.svg";